import "./Policy.css";

function PrivacyPolicy() {
  return (
    <div className="lp-page">

      <div className="lp-hero">
        <div className="lp-hero-tag">🔒 Privacy</div>
        <h1>Privacy Policy</h1>
        <p>We keep it simple — your data is yours. Here's exactly what we collect and why.</p>
      </div>

      <div className="lp-container">
        <div className="lp-meta">
          <span>Last updated: March 2025</span>
          <span className="lp-meta-dot" />
          <span>Learnlia</span>
        </div>

        <div className="lp-section">
          <h2>Information We Collect</h2>
          <p>When you create an account and use Learnlia, we collect:</p>
          <ul>
            <li>Your name and email address (for account creation)</li>
            <li>Learning progress data (videos watched, courses, roadmaps)</li>
            <li>Streak and XP activity to power your dashboard</li>
            <li>Timezone (to calculate streaks accurately)</li>
            <li>Usage analytics to improve the platform</li>
          </ul>
          <p>We do not collect payment information, phone numbers, or any sensitive personal data.</p>
        </div>

        <div className="lp-section">
          <h2>How We Use Your Information</h2>
          <p>Your data is used solely to provide and improve the Learnlia experience:</p>
          <ul>
            <li>Powering your progress tracking, streaks, and XP system</li>
            <li>Generating learning analytics and heatmaps on your dashboard</li>
            <li>Sending verification and account-related emails</li>
            <li>Improving platform features based on usage patterns</li>
          </ul>
          <div className="lp-callout">
            <strong>We do not sell, rent, or share your personal data with third parties</strong> for
            marketing or advertising purposes.
          </div>
        </div>

        <div className="lp-section">
          <h2>YouTube & Third-Party Content</h2>
          <p>
            Learnlia embeds YouTube videos using YouTube's official iframe player.
            When you watch a video, YouTube's own privacy policy applies to that interaction.
            We do not control YouTube's data collection practices.
          </p>
        </div>

        <div className="lp-section">
          <h2>Data Storage & Security</h2>
          <p>
            Your data is stored securely using industry-standard practices including
            encrypted passwords, secure HTTP connections, and protected API endpoints.
            We regularly review our security practices to protect your information.
          </p>
        </div>

        <div className="lp-section">
          <h2>Your Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Request a copy of the data we hold about you</li>
            <li>Request deletion of your account and associated data</li>
            <li>Update your profile information at any time</li>
          </ul>
          <p>
            To exercise these rights, contact us at{" "}
            <a href="mailto:learnliadev@gmail.com" style={{ color: "var(--accent)" }}>
              learnliadev@gmail.com
            </a>
          </p>
        </div>

        <div className="lp-section">
          <h2>Changes to This Policy</h2>
          <p>
            We may update this policy as the platform grows. Any significant changes
            will be communicated via email or a notice on the platform.
          </p>
        </div>

      </div>
    </div>
  );
}

export default PrivacyPolicy;